'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 60%, 75%, 90%, to {\n     animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n   }\n\n   from {\n     opacity: 0;\n     transform: translate3d(3000px, 0, 0);\n   }\n\n   60% {\n     opacity: 1;\n     transform: translate3d(-25px, 0, 0);\n   }\n\n   75% {\n     transform: translate3d(10px, 0, 0);\n   }\n\n   90% {\n     transform: translate3d(-5px, 0, 0);\n   }\n\n   to {\n     transform: none;\n   }\n'], ['\n  from, 60%, 75%, 90%, to {\n     animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n   }\n\n   from {\n     opacity: 0;\n     transform: translate3d(3000px, 0, 0);\n   }\n\n   60% {\n     opacity: 1;\n     transform: translate3d(-25px, 0, 0);\n   }\n\n   75% {\n     transform: translate3d(10px, 0, 0);\n   }\n\n   90% {\n     transform: translate3d(-5px, 0, 0);\n   }\n\n   to {\n     transform: none;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = require('../BaseAnimation');

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceInRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceInRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceInRightAnimation);

exports.default = BounceInRight;


//////////////////
// WEBPACK FOOTER
// ./~/animate-css-styled-components/lib/Bounce/InRight.js
// module id = 499
// module chunks = 95715928098905 168707334958949